module.exports = __webpack_public_path__ + "img/flexsale_banner.cab85785.png";